import template from 'modal/username.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { debug } from '../utils/logger';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';

import {
    sendUserNameData,
    clearUserNameData,
    userNameCanceled
} from '../actions/userNameActions';

import {
    checkForm
} from '../utils/errorHandling';

import {
    userNameModalSaga
} from '../sagas/userSagas';

export function init(store, overrides = {}) {
    const config = {
        name: 'usernameComponent',
        template: template,
        watch: ['core.modal.userName'],
        attachEvents: attachEvents,
        firstRender: firstRender,
        afterCancelAction: afterCancelAction,
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}

function firstRender(store) {
    this.render(store, this);
    attachParsley(this, store);
}

function afterCancelAction(store) {
    store.dispatch(clearUserNameData());
    store.dispatch(userNameCanceled());
}

function afterCloseAction(store) {
    store.dispatch(clearUserNameData());
    // Remove hash and push state on close
    removeHash();
}

export function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), '#user-name', (e) => {
        e.preventDefault();

        const payload = {
            userName: $(this.scopedSelector("[name='username']")).val()
        };

        store.runSaga(userNameModalSaga, payload, this.name);
    });

    // Close modal on back-button
    bindOnPopStateEvent(this, function(e) {
        closeModal(this, e);
    });
}

function attachParsley(component, store) {
    debug('modal: attachParsleyForUserName');

    $('#user-name').parsley().on('field:validated', (e) => {
        const [values, msgs] = checkForm('#user-name');

        let previousMsgs = {};

        if (store.getState().core.modal.userName) {
            previousMsgs = store.getState().core.modal.userName.messages;
        }
        store.dispatch(sendUserNameData(values, msgs, previousMsgs));
    });
}
